import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);

export const time = dayjs;

export const TimeDuration = {
  Second: 1000,
  Minute: 60 * 1000,
  Hour: 60 * 60 * 1000,
} as const;

export const Timezone = {
  Eastern: 'America/New_York',
} as const;

export const DateFormat = {
  /** Fallback display value when a date is empty. Example: -- */
  DefaultDisplayValue: '--',
  /** ISO-like calendar date (no time). Example: 2026-02-12 */
  Calendar: 'YYYY-MM-DD',
  /** Year and month. Example: 2026-02 */
  YearMonth: 'YYYY-MM',
  /** US short date format. Example: 02/12/2026 */
  Us: 'MM/DD/YYYY',
  /** ISO 8601 timestamp with timezone offset. Example: 2026-02-12T14:30:45.000Z */
  Timestamp: 'YYYY-MM-DDTHH:mm:ss.sssZ',
  /** Human-readable long date. Example: February 12, 2026 */
  Pretty: 'MMMM D, YYYY',
  /** 12-hour time format with leading zero for single-digit hours. Example: 07:00 pm */
  Time: 'hh:mm a',
} as const;
